import { Injectable } from '@angular/core';
import { DashboardUserContextService } from '@rma/dashboard/authentication/public/user';
import {
  NotificationBellApiService,
  UserNotificationEventType,
  UserNotificationModel,
} from '@rma/dashboard/notification-bell/private/api-user-notifications';
import { combineLatest, map, Observable, of, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationBellEventService {
  constructor(
    private readonly notificationBellApiService: NotificationBellApiService,
    private readonly userContextService: DashboardUserContextService,
  ) {}

  public markAllAs(notifications: UserNotificationModel[], eventType: UserNotificationEventType): Observable<void> {
    const observables = notifications.map((x) => this.markAs(x, eventType));
    return combineLatest(observables).pipe(
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      map(() => {}),
    );
  }

  public markAs(notification: UserNotificationModel, eventType: UserNotificationEventType): Observable<void> {
    return this.userContextService.isImpersonating$.pipe(
      take(1),
      switchMap((context) => {
        return context ? of() : this.notificationBellApiService.postNotificationEvent(notification.userNotificationCode, eventType);
      }),
    );
  }
}
